<script>
import { OrderStopType } from "@/constants/order.ts";
import PickupInfoDialog from "@/views/trips/view/components/dialogs/PickupInfoDialog.vue";
import DeliveryInfoDialog from "@/views/trips/view/components/dialogs/DeliveryInfoDialog.vue";
import { mapActions } from "pinia";
import { useSnackbarStore } from "@/store/snackbar.store.ts";

export default {
  name: "ShowInfoAction",
  components: { DeliveryInfoDialog, PickupInfoDialog },
  inheritAttrs: false,
  props: {
    trip: Object,
    route: Object,
    stop: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["finish"],
  data() {
    return {
      showDialog: false,
    };
  },
  computed: {
    isPickUp() {
      return this.stop.type === OrderStopType.pickup;
    },
    isDelivery() {
      return this.stop.type === OrderStopType.delivery;
    },
  },
  methods: {
    ...mapActions(useSnackbarStore, ["showSnackbarError"]),
    showInfo() {
      this.showDialog = true;
    },
  },
};
</script>

<template>
  <v-btn
    :disabled="disabled"
    block
    class="text-uppercase font-weight-600"
    color="primary"
    v-bind="$attrs"
    variant="outlined"
    @click="showInfo"
  >
    View info
  </v-btn>

  <pickup-info-dialog
    v-if="isPickUp"
    v-model="showDialog"
    :route="route"
    :stop="stop"
    :trip-id="trip.id"
    preload
    readonly
    title="Pick up information"
  ></pickup-info-dialog>

  <delivery-info-dialog
    v-if="isDelivery"
    v-model="showDialog"
    :route="route"
    :stop="stop"
    :trip-id="trip.id"
    preload
    readonly
    title="Delivery information"
  ></delivery-info-dialog>
</template>

<style lang="scss" scoped></style>
